import React, { useEffect } from 'react';
import { Card, Typography } from 'antd';
import { setTheme } from "@/AppRedux/actions/theme/index";
import { useDispatch } from 'react-redux';
import { themeDefault } from "@/AppRedux/sagas/theme/themeMockupTemplate";
const { Title, Paragraph } = Typography;

const AdminLanding = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setTheme(themeDefault));
  }, [dispatch]);
  return (
    <Card>
      <Title level={2}>ยินดีต้อนรับเข้าสู่ระบบการจัดการเนื้อหาของเว็บไซต์</Title>
      <Paragraph>
        (Welcome to the website's Content management system)
      </Paragraph>
      <Paragraph>
        You can manage the content settings by clicking on the "Content Settings" menu item on the left.
      </Paragraph>
    </Card>
  );
};

export default AdminLanding;
